export const jsonParser = (jsonToParse) => {
  return JSON.parse(jsonToParse.replace(/^"|"$/g, ''));
};

export const arraySorter = (array) => {
  return array?.sort((a, b) => a.order - b.order);
};

export const addRemoveArray = (array = [], isAdd, selectedData) => {
  return isAdd ? [...array, selectedData] : array?.filter(item => item !== selectedData);
};

export const filterArray = (array, value, key) => {
  return array?.filter((item) => {
    const nestedValue = key.split('.').reduce((obj, keyPart) => obj?.[keyPart], item);
    return nestedValue === value;
  });
};

export const removeNullValues = (object) => {
  return Object.fromEntries(
    Object.entries(object).filter(([_, value]) => value !== null && value !== '')
  );
};

export const findIndex = (currentList, currentData, compare = 'id') => {
  return [...currentList].findIndex((element) => element[compare] == currentData[compare]);
};

export const pushToArray = (currentList, data) => {
  const updatedList = [...currentList];
  updatedList.push(data);
  return updatedList;
};

export const unshiftToArray = (currentList, data) => {
  const updatedList = [...currentList];
  updatedList.unshift(data);
  return updatedList;
};

export const manageAddOrUpdate = (currentList, currentData, compare = 'id', type = 'unshift') => {
  let updatedlist = [...currentList];
  const idx = findIndex(updatedlist, currentData, compare);
  if (idx == -1) {
    if (type == 'push') {
      updatedlist = pushToArray(updatedlist, currentData);
    } else {
      updatedlist = unshiftToArray(updatedlist, currentData);
    }
  } else {
    updatedlist[idx] = { ...currentData };
  }
  return [...updatedlist];
};

export const arrayRandomizer = (array = [], limit) => {
  const randomized = array?.sort(() => 0.5 - Math.random());
  return limit ? randomized.slice(0, limit) : randomized;
};

export const searchRegex = (val) => {
  return val.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

export const frontendSearch = (listRows, search) => {
  const regex = new RegExp(searchRegex(search ?? ''), 'i');
  listRows = listRows.filter((val) => {
    return Object.keys(val).some((field) => {
      return regex.test(val[field]?.toString());
    });
  });
  return listRows;
};

export const arrayToObject = (array, key) =>
  array.reduce((acc, item) => {
    acc[item] = { [key]: item };
    return acc;
  }, {});